import React from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { process } from "@progress/kendo-data-query";

export default class SalesRepUsersGrid extends React.Component {
  constructor(props) {
    super(props);
    this._export = null;
    this.state = {
      data: (this.props.users || []).slice(),
      dataState: {
        skip: 0,
        take: 20,
        sort: [{ field: "name", dir: "asc" }]
      },
      search: ""
    };
  }

  onDataStateChange = (e) => {
    this.setState({ dataState: e.dataState });
  };

  getFilteredData = () => {
    var data = this.state.data;
    if (this.state.search) {
      var s = this.state.search.toLowerCase();
      data = data.filter(d =>
        (d.name || "").toLowerCase().indexOf(s) > -1 ||
        (d.email || "").toLowerCase().indexOf(s) > -1 ||
        (d.company || "").toLowerCase().indexOf(s) > -1
      );
    }
    return data;
  };

  onRefresh = () => {
    this.setState({
      dataState: { skip: 0, take: 20, sort: [{ field: "name", dir: "asc" }] },
      search: ""
    });
  };

  exportExcel = () => {
    if (this._export) {
      this._export.save(this.getFilteredData());
    }
  };

  toggleUserStatus = (userId, currentStatus) => {
    var newStatus = !currentStatus;
    fetch("/api/profile/ToggleUserStatus", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: userId, isActive: newStatus })
    })
      .then(res => {
        if (res.ok) {
          this.setState(prev => ({
            data: prev.data.map(u =>
              u.id === userId ? { ...u, isApproved: newStatus } : u
            )
          }));
        }
      });
  };

  render() {
    var filteredData = this.getFilteredData();
    var result = process(filteredData, this.state.dataState);

    return (
      <div>
        <div className="quote-history-filters">
          <div className="quote-filter-item">
            <label>Search</label>
            <input
              type="text"
              placeholder="Name, email, or company..."
              value={this.state.search}
              onChange={(e) => this.setState({ search: e.target.value, dataState: { ...this.state.dataState, skip: 0 } })}
              style={{ padding: "8px 12px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "14px", width: "260px" }}
            />
          </div>
        </div>

        <ExcelExport ref={(exp) => { this._export = exp; }} fileName="MyUsers.xlsx">
          <Grid
            data={result}
            {...this.state.dataState}
            onDataStateChange={this.onDataStateChange}
            sortable={true}
            pageable={{ pageSizes: [10, 20, 50] }}
            cellRender={(cell, cellProps) => {
              if (!cell || !cell.props) return cell;
              const labels = { name: "Name", email: "Email", company: "Company", phoneNumber: "Phone", isApproved: "Status", lastActivityDate: "Last Activity", createdAt: "Created" };
              const label = labels[cellProps.field] || "";
              return React.cloneElement(cell, { ...cell.props, "data-label": label });
            }}
          >
            <GridToolbar>
              <button className="ui-button secondary min-width" onClick={this.exportExcel}
                style={{ background: "#333", color: "#fff", border: "none", padding: "8px 16px", cursor: "pointer", fontSize: "13px" }}>
                Export to Excel
              </button>
              <button className="ui-button secondary min-width" onClick={this.onRefresh}
                style={{ marginLeft: "auto", padding: "8px 16px", cursor: "pointer", fontSize: "13px" }}>
                Refresh
              </button>
            </GridToolbar>
            <GridColumn field="name" title="Name" width="180px" />
            <GridColumn field="email" title="Email" width="220px" />
            <GridColumn field="company" title="Company" />
            <GridColumn field="phoneNumber" title="Phone" width="140px" />
            <GridColumn field="isApproved" title="Status" width="110px"
              cell={(props) => (
                <td data-label="Status">
                  <button
                    onClick={() => this.toggleUserStatus(props.dataItem.id, props.dataItem.isApproved)}
                    className={"admin-status-toggle " + (props.dataItem.isApproved ? "active" : "disabled")}
                  >
                    {props.dataItem.isApproved ? "Active" : "Disabled"}
                  </button>
                </td>
              )}
            />
            <GridColumn field="lastActivityDate" title="Last Activity" width="110px" />
            <GridColumn field="createdAt" title="Created" width="100px"
              cell={(props) => (
                <td title={props.dataItem.createdAt} data-label="Created">{props.dataItem.createdAt}</td>
              )}
            />
          </Grid>
        </ExcelExport>
      </div>
    );
  }
}
